export default "__VITE_ASSET__COxwFV_R__"